<template>
  <form @submit.prevent="validateBeforeSubmit">
    <b-field grouped>
      <b-field
        label="CPF/CNPJ*"
        expanded
        :type="{ 'is-danger': errors.has('document') }"
        :message="errors.first('document')"
      >
        <b-input
          v-model="data.document"
          type="text"
          name="document"
          maxlength="18"
          :has-counter="false"
          v-validate="'required|document'"
          data-vv-as="documento"
          v-cleave="masks.CNPJ"
          :disabled="isEdit"
          @input.native="cleaveRefresh($event,  {ranges: {0: 'CPF', 15: 'CNPJ'}})"
        />
      </b-field>

      <b-field
        label="Nome"
        expanded
        :type="{ 'is-danger': errors.has('name') }"
        :message="errors.first('name')"
      >
        <b-input v-model="data.name" name="name" />
      </b-field>

    </b-field>
    <b-field grouped>
      <b-field
        label="Departamento"
        expanded
        :type="{ 'is-danger': errors.has('department') }"
        :message="errors.first('department')"
      >
        <b-input v-model="data.department" name="department" />
      </b-field>
      <b-field
        label="Código Interno"
        expanded
        :type="{ 'is-danger': errors.has('externalCode') }"
        :message="errors.first('externalCode')"
      >
        <b-input v-model="data.externalCode" name="externalCode" />
      </b-field>
    </b-field>

    <b-field
      label="Grupo de restrição"
      :type="{ 'is-danger': errors.has('restriction') }"
      :message="errors.first('restriction')"
      expanded
    >
      <b-select
        placeholder="Selecione uma restrição"
        expanded
        v-model="data.restrictionGroupId"
        v-validate="'required'"
        name="restriction"
        data-vv-as="grupo de restrição"
      >
        <option
          v-for="option in restrictions"
          :value="option.id"
          :key="option.id"
        >
          {{ option.title }}
        </option>
      </b-select>
    </b-field>

    <hr />
    <div class="buttons is-right">
      <router-link class="button is-rounded" :to="'/motoristas'"
        >Voltar</router-link
      >
      <button
        class="button is-rounded is-primary"
        type="submit"
        @click.prevent="validateAndSubmit"
      >
        Salvar
      </button>
    </div>
  </form>
</template>

<script>
import cleave, { cleaveRefresh, masks } from "../../directives/cleave.js";
import restrictions from "../../services/restrictions";

export default {
  props: {
    data: Object,
    isEdit: Boolean,
  },
  directives: {
    cleave
  },
  data() {
    return {
      masks,
      cleaveRefresh,
      restrictions: [],
      vehicles: []
    };
  },
  mounted() {
    this.loadRestrictions();
  },
  methods: {
    async loadRestrictions() {
      try {
        const response = await restrictions.all();
        this.restrictions = response;

        if (this.restrictions.length > 0) {
          this.data.restrictionGroupId = this.restrictions[0].id;
        }
      } catch (err) {
        this.$buefy.toast.open({
          message: "Erro ao carregar a lista de restrições.",
          type: "is-danger"
        });
      }
    },
    validateAndSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("save", this.getRawData());
          return;
        }
        this.$buefy.toast.open({
          message: "Verfique os campos marcados para continuar.",
          type: "is-danger"
        });
      });
    },
    getRawData() {
      const rawData = { ...this.data };

      rawData.document = this.getUnformattedDocument(rawData.document);
      rawData.zipCode = this.getUnformattedNumber(rawData.zipCode);

      return rawData;
    },
    getUnformattedDocument(value) {
      if (!value) return value;

      const alphaNumericMatches = value.toUpperCase().match(/[0-9A-Z]+/g);
      return alphaNumericMatches ? alphaNumericMatches.join("") : "";
    },
    getUnformattedNumber(value) {
      if (value) return value.match(/\d+/g).join("");
    }
  }
};
</script>
